// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"467":"e580a004","981":"a0e10f76"}[chunkId] + ".chunk.css";
};